import * as React from "react";
import { BackgroundImage } from '../library/BackgroundImage';
import { ComponentImage } from '../library/ComponentImage';

const COMPONENT_NAME = "RedditFrame";
const REDDIT_URL = "https://api.reddit.com/r/";
const cx = require('classNames');

const Tabs = {
    HOT: 0,
    TOP: 1,
    NEW: 2
};

export class RedditFrame extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            selectedStory: '',
            hotStories: [],
            topStories: [],
            newStories: [],
            selectedTab: Tabs.HOT
        };

        const url = REDDIT_URL + props.subreddit;

        fetch(url + "/hot").then((response) => {
            return response.json();
        }).then((data) =>{
            const stories = data.data.children.filter((story) => !story.data.stickied);
            this.setState((prevState) => {
                prevState.hotStories = stories;
                prevState.isLoading = false;
                return prevState;
            });
        });

        fetch(url + "/new").then((response) => {
            return response.json();
        }).then((data) =>{
            const stories = data.data.children.filter((story) => !story.data.stickied);
            this.setState((prevState) => {
                prevState.newStories = stories;
                return prevState;
            });
        });

        fetch(url + "/top/?sort=top&t=week").then((response) => {
            return response.json();
        }).then((data) =>{
            const stories = data.data.children.filter((story) => !story.data.stickied);
            this.setState((prevState) => {
                prevState.topStories = stories;
                return prevState;
            });
        });
    }

    selectStory(story) {
        const url =`https://reddit.com${story.data.permalink}`;
        window.open(url, "s", "width= 1400, height= 1024, left=300, top=0, resizable=yes, toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=yes, copyhistory=no").blur();
        window.focus();
    }

    selectTab(tab) {
        this.setState((prevState) => {
            prevState.selectedTab = tab;
            return prevState;
        });
    }

    renderTabs() {
        const { isLoading, selectedTab } = this.state;
        if (isLoading) {
            return null;
        }
        
        return (
            <div className="tabs">
                <div className={cx({'tab':true, 'selected': selectedTab === Tabs.HOT})}
                    onClick={()=>{this.selectTab(Tabs.HOT)}}
                >
                    Hot
                </div>
                <div className={cx({'tab':true, 'selected': selectedTab === Tabs.NEW})}
                    onClick={()=>{this.selectTab(Tabs.NEW)}}
                >
                    New
                </div>
                <div className={cx({'tab':true, 'selected': selectedTab === Tabs.TOP})}
                    onClick={()=>{this.selectTab(Tabs.TOP)}}
                >
                    Top
                </div>
            </div>
        );
    }

    renderStories() {
        const { selectedTab, hotStories, topStories, newStories } = this.state;
        let stories = [];
        if (selectedTab === Tabs.HOT) {
            stories = hotStories; 
        } else if (selectedTab === Tabs.TOP) {
            stories = topStories; 
        } else if (selectedTab === Tabs.NEW) {
            stories = newStories; 
        } 

        stories = stories.map((story) => (
            <div className="story" onClick={()=>this.selectStory(story)}>
                {
                    story.data.thumbnail.indexOf('http') !== 0 ?
                        <BackgroundImage
                            className="thumbnail"
                            component={COMPONENT_NAME}
                            file={'placeholder.gif'} />:
                        <BackgroundImage
                            className="thumbnail"
                            src={story.data.thumbnail} />
                }
                <div className="description">
                    <div className="title">
                        {story.data.title}
                    </div>
                    <div className="domain">
                        {`(${story.data.domain})`}
                    </div>
                </div>
            </div>
        ));

        return (
            <div className="stories">
                {stories}
            </div>
        );
    }
    

    render() {
        const { selectedStory } = this.state;
        const url = selectedStory ? 
            `https://reddit.com/${this.state.selectedStory.data.permalink}`:
            '';
        return (
            <div className="RedditFrame">
                {this.renderTabs()}
                {this.renderStories()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./react/components/RedditFrame.jsx